module.exports = __webpack_public_path__ + "img/usaMap.5c38cbdc.gif";